import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import ScoreCompanyService from '../../../../../../core/service'

// getScoreCreditRisk
export const getScoreCreditRisk = createAsyncThunk(
  'companyAnalysis/companyScore/getScoreCreditRisk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getScoreCreditRisk(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
